import { render, staticRenderFns } from "./DMSDocument.vue?vue&type=template&id=30eaa53b&scoped=true&"
import script from "./DMSDocument.vue?vue&type=script&lang=js&"
export * from "./DMSDocument.vue?vue&type=script&lang=js&"
import style0 from "./DMSDocument.scss?vue&type=style&index=0&id=30eaa53b&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eaa53b",
  null
  
)

export default component.exports